/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleInfoFill: {
  name: 'circle-info-fill';
  data: string;
} = {
  name: 'circle-info-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm.5 11a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 1 0v5ZM8 4a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
